"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function ScheduleAndRetentionGreyOutline(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__schedule-and-retention-grey-outline__clip0_17868_4291)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M11.548 10.156V12.7c0 .959-2.213 2.038-5.174 2.038-2.961 0-5.175-1.08-5.175-2.038V4.34s0-.02.004-.032a.043.043 0 01.004-.032c.156-.923 2.27-1.905 5.07-1.93.009-.015.017-.027.02-.043.184-.41.412-.795.688-1.148-.2-.008-.404-.012-.611-.012-3.52 0-6.202 1.308-6.366 3.069-.004.032-.008.06-.004.088C0 4.312 0 4.328 0 4.34v8.315c0 .056.004.116.008.172.12 1.781 2.817 3.113 6.366 3.113 3.548 0 6.373-1.396 6.373-3.24V9.991a5.397 5.397 0 01-1.199.164z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M6.122 6.373c-2.81-.056-4.887-1.082-4.923-2.009v1.913c1.135.802 2.993 1.304 5.175 1.304.107 0 .215 0 .323-.004a5.286 5.286 0 01-.575-1.204zm-4.92-2.065s0-.024.005-.032c.092-.935 2.237-1.954 5.09-1.974.184-.409.412-.794.688-1.147.008-.016.02-.028.032-.04a11.387 11.387 0 00-.643-.016C2.825 1.099.128 2.431.008 4.212c-.004.032-.008.06-.004.088C0 4.312 0 4.328 0 4.34v.044c.016.722.456 1.372 1.199 1.893 1.135.802 2.993 1.304 5.175 1.304.107 0 .215 0 .323-.004a5.286 5.286 0 01-.575-1.204c-2.81-.056-4.887-1.082-4.923-2.009V4.34s0-.02.004-.032zm4.92 2.066c-2.81-.057-4.887-1.083-4.923-2.01v1.913c1.135.802 2.993 1.304 5.175 1.304.107 0 .215 0 .323-.004a5.286 5.286 0 01-.575-1.204zM6.374 15.896C2.74 15.896 0 14.504 0 12.655a.6.6 0 111.199 0c0 .962 2.214 2.037 5.175 2.037 2.96 0 5.174-1.075 5.174-2.037a.6.6 0 111.2 0c0 1.849-2.742 3.24-6.374 3.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M.6 13.256a.6.6 0 01-.6-.601V8.186a.6.6 0 111.199 0v4.469a.6.6 0 01-.6.601z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M.6 8.784a.6.6 0 01-.6-.602V4.34a.6.6 0 111.199 0v3.842a.6.6 0 01-.6.602zM11.548 10.156a5.399 5.399 0 001.199-.165v2.664s0 .028-.004.04c.004.012 0 .024-.004.036a.597.597 0 01-1.19-.076v-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M11.388 10.16c.036 0 .072 0 .108-.004-1.143.782-2.977 1.268-5.122 1.268-2.146 0-4.04-.502-5.175-1.304C.439 9.586 0 8.92 0 8.183c0-.33.268-.602.6-.602.331 0 .599.273.599.602 0 .962 2.214 2.037 5.175 2.037 1.158 0 2.201-.164 3.04-.421a5.524 5.524 0 001.97.361h.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0071BC",
    d: "M11.5 10.156l.049-.036v.036s-.033.004-.049 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M11.388 0C10.186 0 9.095.47 8.28 1.235c-.012.012-.028.024-.04.04a4.469 4.469 0 00-.824 1.071.096.096 0 00-.024.045 4.525 4.525 0 00-.555 2.182 4.537 4.537 0 001.059 2.92 4.525 4.525 0 002.997 1.62h.004c.164.02.324.028.491.028.052 0 .108 0 .16-.004a4.463 4.463 0 001.199-.204 4.57 4.57 0 003.193-4.36C15.94 2.05 13.898 0 11.388 0zm1.359 7.649h-.004a3.262 3.262 0 01-1.139.28c-.016.005-.036.005-.056.005h-.004a3.297 3.297 0 01-2.206-.702 3.349 3.349 0 01-1.303-2.66c0-.745.24-1.435.652-1.993.008-.012.016-.024.028-.036a3.427 3.427 0 011.063-.927c.02-.008.036-.02.052-.028a3.345 3.345 0 011.558-.385c1.85 0 3.353 1.512 3.353 3.37 0 1.371-.82 2.55-1.994 3.076zm-1.203.285a3.297 3.297 0 01-2.206-.702c-.235.06-.475.112-.727.16a3.927 3.927 0 002.777 1.147h.06a.76.76 0 00.096-.357c0-.012 0-.028.004-.04v-.208h-.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M13.366 5.174h-1.978a.6.6 0 01-.6-.601V2.587a.6.6 0 111.2 0v1.384h1.378a.6.6 0 01.6.602.6.6 0 01-.6.601z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__schedule-and-retention-grey-outline__clip0_17868_4291"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V16H0z"
  }))));
}

ScheduleAndRetentionGreyOutline.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
ScheduleAndRetentionGreyOutline.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = ScheduleAndRetentionGreyOutline;
exports["default"] = _default;